export function calculateInterest(financedPrincipal, mode = "none", rate = 0, fixedAmount = 0) {
  const principal = Math.max(0, Number(financedPrincipal) || 0);
  if (mode === "percent") return Math.max(0, roundMoney(principal * (Math.max(0, Number(rate) || 0) / 100)));
  if (mode === "fixed") return Math.max(0, roundMoney(fixedAmount));
  return 0;
}

export function calculateContractPlan({ totalPrice, downPayment, installmentAmount, interestMode = "none", interestRate = 0, interestAmount = 0 }) {
  const price = roundMoney(totalPrice);
  const down = roundMoney(downPayment);
  const installment = roundMoney(installmentAmount);
  const financedPrincipal = roundMoney(Math.max(0, price - down));
  const monthlyInterest = calculateInterest(financedPrincipal, interestMode, interestRate, interestAmount);
  const monthlyPrincipal = roundMoney(installment - monthlyInterest);
  const totalInstallments = monthlyPrincipal > 0 ? Math.ceil(financedPrincipal / monthlyPrincipal) : 0;
  const totalInterest = roundMoney(totalInstallments * monthlyInterest);
  const finalPrincipal = totalInstallments ? roundMoney(financedPrincipal - monthlyPrincipal * (totalInstallments - 1)) : 0;
  const finalInstallment = totalInstallments ? roundMoney(finalPrincipal + monthlyInterest) : 0;
  return { financedPrincipal, monthlyInterest, monthlyPrincipal, totalInstallments, totalInterest, finalPrincipal, finalInstallment };
}

export function calculatePayoff(remainingPrincipal, monthlyInterest) {
  const principal = roundMoney(Math.max(0, Number(remainingPrincipal) || 0));
  return principal > 0 ? roundMoney(principal + Math.max(0, Number(monthlyInterest) || 0)) : 0;
}

export function calculatePrepaymentPlan({ remainingPrincipal, extraPrincipal, monthlyPrincipal, monthlyInterest }) {
  const before = roundMoney(Math.max(0, Number(remainingPrincipal) || 0));
  const extra = roundMoney(Math.min(before, Math.max(0, Number(extraPrincipal) || 0)));
  const principalPerInstallment = roundMoney(Math.max(0, Number(monthlyPrincipal) || 0));
  const interestPerInstallment = roundMoney(Math.max(0, Number(monthlyInterest) || 0));
  const after = roundMoney(Math.max(0, before - extra));
  const installmentsBefore = principalPerInstallment > 0 ? Math.ceil(before / principalPerInstallment) : 0;
  const installmentsAfter = principalPerInstallment > 0 ? Math.ceil(after / principalPerInstallment) : 0;
  const finalPrincipal = installmentsAfter ? roundMoney(after - principalPerInstallment * (installmentsAfter - 1)) : 0;
  return {
    appliedPrincipal: extra,
    remainingPrincipal: after,
    installmentsBefore,
    installmentsAfter,
    installmentsReduced: Math.max(0, installmentsBefore - installmentsAfter),
    interestReduced: roundMoney(Math.max(0, installmentsBefore - installmentsAfter) * interestPerInstallment),
    finalInstallment: installmentsAfter ? roundMoney(finalPrincipal + interestPerInstallment) : 0,
  };
}

export function roundMoney(value) {
  return Math.round((Number(value) || 0) * 100) / 100;
}
